import { useState } from 'react';
import { useIsMobile } from './useIsMobile';

export const useMobileLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const isMobile = useIsMobile();

    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
    const closeSidebar = () => setIsSidebarOpen(false);

    return {
        isSidebarOpen,
        isMobile,
        toggleSidebar,
        closeSidebar,
        isMobileMenuOpen: isMobile ? isSidebarOpen : true,
        layoutClassName: isMobile && isSidebarOpen ? 'sidebar-open' : ''
    };
}; 
